export class PaginatorController {
    oddNumberOfPagesToShow: number;
    pages: any[];
    currentPage: number;
    onSetPage: Function;

    getPageNumbers(): number[] {
        return this.pages.slice(1, this.pages.length-1).map((page, index) => { return index + 2; });
    }

    filterPageNumbers = (actual: number): boolean => {
        return actual >= this.minPageNumber() && actual <= this.maxPageNumber();
    };

    currentIsFirst(): boolean { return this.currentPage === 1; }

    currentIsLast(): boolean { return this.currentPage === this.pages.length; }

    isCurrent(page: number): boolean { return this.currentPage === page; }

    moreLeft(): boolean { return this.minPageNumber() > 2; }

    moreRight(): boolean { return this.maxPageNumber() < this.pages.length - 1; }

    setPage(page: number): void {
        this.currentPage = page;
        this.onSetPage({ page: page });
    }

    private maxPageNumber(): number {
        return Math.max(
            this.oddNumberOfPagesToShow,
            Math.min(this.pages.length, this.currentPage + Math.floor(this.oddNumberOfPagesToShow / 2))
        );
    }

    private minPageNumber(): number {
        return Math.min(
            this.pages.length - this.oddNumberOfPagesToShow + 1,
            Math.max(1, this.currentPage - Math.floor(this.oddNumberOfPagesToShow/2))
        );
    }
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/paginator/paginator.controller.ts
 **/